class ScRecommendationsRail extends HTMLElement {
  connectedCallback() {
    this.rail = this.querySelector('[data-sc-product-rail]');
    this.previousButton = this.querySelector('[data-sc-origin-scroll="previous"]');
    this.nextButton = this.querySelector('[data-sc-origin-scroll="next"]');
    this.progress = this.querySelector('[data-sc-product-progress]');

    if (!this.rail || !this.previousButton || !this.nextButton) return;

    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.edgeTolerance = 2;
    this.scrollFrame = null;
    this.handleClick = this.handleClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.update = this.update.bind(this);

    this.previousButton.setAttribute('aria-controls', this.rail.id);
    this.nextButton.setAttribute('aria-controls', this.rail.id);
    this.addEventListener('click', this.handleClick);
    this.rail.addEventListener('scroll', this.handleScroll, { passive: true });

    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.rail);
    requestAnimationFrame(this.update);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.rail?.removeEventListener('scroll', this.handleScroll);
    this.resizeObserver?.disconnect();
    if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
  }

  scrollStep() {
    const card = this.rail.querySelector('.sc-product-card');
    if (!card) return this.rail.clientWidth * 0.8;

    const gap = Number.parseFloat(window.getComputedStyle(this.rail).gap) || 0;
    const cardsPerStep = window.matchMedia('(min-width: 990px)').matches ? 2 : 1;
    return (card.getBoundingClientRect().width + gap) * cardsPerStep;
  }

  handleClick(event) {
    const button = event.target.closest('[data-sc-origin-scroll]');
    if (!button || button.disabled || !this.contains(button)) return;

    const direction = button.dataset.scOriginScroll === 'previous' ? -1 : 1;
    const maxScrollLeft = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
    const targetScrollLeft = Math.min(
      maxScrollLeft,
      Math.max(0, this.rail.scrollLeft + direction * this.scrollStep())
    );

    this.rail.scrollTo({
      left: targetScrollLeft,
      behavior: this.prefersReducedMotion.matches ? 'auto' : 'smooth',
    });
  }

  handleScroll() {
    if (this.scrollFrame) return;
    this.scrollFrame = requestAnimationFrame(() => {
      this.update();
      this.scrollFrame = null;
    });
  }

  update() {
    const maxScrollLeft = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
    const progressRatio = maxScrollLeft > 0 ? this.rail.scrollLeft / maxScrollLeft : 0;

    this.previousButton.disabled = this.rail.scrollLeft <= this.edgeTolerance;
    this.nextButton.disabled = this.rail.scrollLeft >= maxScrollLeft - this.edgeTolerance;

    if (!this.progress) return;
    const visibleRatio = Math.min(1, this.rail.clientWidth / Math.max(this.rail.scrollWidth, 1));
    const progressWidth = visibleRatio * 100;
    this.progress.style.width = `${progressWidth}%`;
    this.progress.style.marginInlineStart = `${(100 - progressWidth) * progressRatio}%`;
  }
}

if (!customElements.get('sc-recommendations-rail')) {
  customElements.define('sc-recommendations-rail', ScRecommendationsRail);
}
